/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * Base typography styles for Material Dashboard 2 React.
 */

import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { dark } = colors;

const baseProperties = {
  fontFamily: '"Public Sans", "Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: pxToRem(14),
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,

  // Taille typographiques supplémentaires utilisées dans les composants
  size: {
    xxs: pxToRem(10),
    xs: pxToRem(12),
    sm: pxToRem(14),
    md: pxToRem(16),
    lg: pxToRem(18),
    xl: pxToRem(20),
    "2xl": pxToRem(24),
    "3xl": pxToRem(30),
  },
};

const typography = {
  fontFamily: baseProperties.fontFamily,
  fontSize: baseProperties.fontSize,

  fontWeightLight: baseProperties.fontWeightLight,
  fontWeightRegular: baseProperties.fontWeightRegular,
  fontWeightMedium: baseProperties.fontWeightMedium,
  fontWeightBold: baseProperties.fontWeightBold,

  size: baseProperties.size, // ✅ important pour tous les composants

  h1: {
    fontSize: pxToRem(36),
    fontWeight: baseProperties.fontWeightBold,
    lineHeight: 1.25,
  },

  h2: {
    fontSize: pxToRem(30),
    fontWeight: baseProperties.fontWeightBold,
    lineHeight: 1.3,
  },

  h3: {
    fontSize: pxToRem(24),
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.4,
  },

  h4: {
    fontSize: pxToRem(20),
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.4,
  },

  h5: {
    fontSize: pxToRem(18),
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.5,
  },

  h6: {
    fontSize: pxToRem(16),
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.5,
  },

  subtitle1: {
    fontSize: pxToRem(16),
    fontWeight: baseProperties.fontWeightRegular,
    lineHeight: 1.75,
  },

  subtitle2: {
    fontSize: pxToRem(14),
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.6,
  },

  body1: {
    fontSize: pxToRem(14),
    fontWeight: baseProperties.fontWeightRegular,
    lineHeight: 1.5,
  },

  body2: {
    fontSize: pxToRem(13),
    fontWeight: baseProperties.fontWeightRegular,
    lineHeight: 1.43,
  },

  button: {
    fontSize: pxToRem(14),
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.5,
    textTransform: "none",
  },

  caption: {
    fontSize: pxToRem(12),
    fontWeight: baseProperties.fontWeightRegular,
    lineHeight: 1.25,
  },

  overline: {
    fontSize: pxToRem(10),
    fontWeight: baseProperties.fontWeightMedium,
    textTransform: "uppercase",
  },
};

export default typography;
